import { createFileRoute } from "@tanstack/react-router";
import { LabelExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/foundations/labels")({
  component: LabelExamples,
});
